import React, { useEffect, useState } from "react";
import ReactSeamlessScroll from "react-seamless-scroll";
import "../style/table.css";

const TablePlay = (props) => {
  const { subData } = props;
  return (
    <tr>
      <td className="rank">
        <p>
          <span>{subData.rank}</span>
        </p>
      </td>
      <td>{subData.number}</td>
      <td>{subData.name}</td>
      <td>{subData.totalSubScore}</td>
      <td>{subData.company}</td>
    </tr>
  );
};
const ListNotScroll = (props) => {
  const { data } = props;
  return (
    <table className="table-play">
      <tbody>
        {data &&
          data
            .slice(3)
            .map((item, index) => (
              <TablePlay subData={item} key={index + Math.random()} />
            ))}
      </tbody>
    </table>
  );
};
const ListScroll = (props) => {
  const { data } = props;
  return (
    <ReactSeamlessScroll>
      <table className="table-play">
        <tbody>
          {data &&
            data
              .slice(3)
              .map((item, index) => (
                <TablePlay subData={item} key={index + Math.random()} />
              ))}
        </tbody>
      </table>
    </ReactSeamlessScroll>
  );
};

const Broadcast = React.memo((props) => {
  const { playData, height } = props;

  let [data, setData] = useState([]);
  useEffect(() => {
    if (!playData) return;
    setData(playData);
  });

  return (
    <div style={{ height: height / 2 + 20 }}>
      {
        data && data.length < 6 ? 
        <ListNotScroll data={data} /> :
        <ListScroll data={data} />
      }
    </div>
  );
});

export default Broadcast;
